import axios from 'axios'

const url = {
  avatar: '/api/me/avatar'
}

export default {
  async updateAvatar (formData) {
    return await axios.post(url.avatar, formData)
  }
}
